import { createContext, useContext, type Context } from 'react';

export const SuspenseBoundaryNameContext: Context<string[]> = createContext<string[]>([]);

export const useSuspenseBoundaryName = (): string[] => {
	return useContext(SuspenseBoundaryNameContext);
};
